import { render } from "./Home.vue?vue&type=template&id=0642ad21&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0642ad21&scoped=true&lang=css"

import exportComponent from "/Users/ginea/Desktop/template_demo/vuejs-tailwindcss-portfolio-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0642ad21"]])

export default __exports__